<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import { mapGetters } from "vuex";
	export default {
		name: 'App',
		created() {
			sessionStorage.setItem('fristUrl',window.location.href)	
			document.addEventListener('visibilitychange', this.handleVisibilityChange);
		},
        beforeDestroy() {
            document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        },
		watch:{
			'identity':{
				handler(n){
					if(!n.data || !n.data.account){
						return
					}
					localStorage.setItem('identity_tmp', n.data.account + '$' + n.data.merchantId)
				},
				deep:true,
				immediate:true
			}
		},
		computed:{
			...mapGetters([ "identity"]),
		},
        methods: {
            handleVisibilityChange() {
                if (document.visibilityState === 'visible') {
					if(this.$store.state.racl){
							
						let identity_tmp = localStorage.getItem("identity_tmp");
						let current = this.$store.state.racl.identity.data.account + '$' + this.$store.state.racl.identity.data.merchantId;
						if(identity_tmp != current){
							if(confirm('登录信息不一致,是否关闭当前页面')){
								window.location.href = "/"
							}
						}

					}
                }
            }
        }
	}
</script>
